import React from 'react';

import { getAsset } from '../../../../../../../util/assets';

const NoUploadsNullState = ({ identity }) => {
  return (
    <div className="d-flex flex-column align-items-center mt-3">
      <img
        src={getAsset('/waldo-icon.svg')}
        className="grayscale-faded mb-3"
        width="40"
        alt="Waldo Icon"
      />
      <h3 className="text-extra-bold text-center mb-1">
        No photos uploaded in this album yet!
      </h3>
      {identity && (
        <p className="m-0 text-light text-bold text-center">
          I&rsquo;ll send you an alert the moment I find your matching photos in
          this event!
        </p>
      )}
    </div>
  );
};

export default NoUploadsNullState;
